// Outline (stroke) gift, matching the stroked sidebar icons in ./sidebar/*.
// Only consumer is the Perks & Benefits sidebar nav item.
export const Gift = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="2.5"
      y="6.6665"
      width="15"
      height="3.33333"
      rx="0.833333"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 6.6665V17.4998"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.8333 9.99984V15.8332C15.8333 16.7536 15.0871 17.4998 14.1666 17.4998H5.83329C4.91282 17.4998 4.16663 16.7536 4.16663 15.8332V9.99984"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.24996 6.6665C5.09937 6.6665 4.16663 5.73376 4.16663 4.58317C4.16663 3.43258 5.09937 2.49984 6.24996 2.49984C7.39167 2.49984 8.38226 3.0145 9.10318 3.7895C9.66722 4.39542 9.99996 5.49775 9.99996 6.6665C9.99996 5.49775 10.3327 4.39542 10.8967 3.7895C11.6177 3.0145 12.6083 2.49984 13.75 2.49984C14.9006 2.49984 15.8333 3.43258 15.8333 4.58317C15.8333 5.73376 14.9006 6.6665 13.75 6.6665"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default Gift
